import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FilterSidebarWrapper from 'apps/catalogue/containers/sidebar/FilterSidebarWrapper';
import Filters from 'apps/catalogue/containers/sidebar/Filters';
import FiltersPageStatistics from './analytics/FiltersPageStatistics';

export default class ProductsPageFilterSidebar extends PureComponent {
  static propTypes = {
    basePath: PropTypes.string.isRequired,
    filters: PropTypes.array,
    filtersBrandsCount: PropTypes.number,
    location: PropTypes.string,
    pageParameters: PropTypes.object.isRequired,
    routeString: PropTypes.string.isRequired,
  };

  render() {
    const {
      basePath,
      filters,
      filtersBrandsCount,
      location,
      pageParameters,
      routeString,
    } = this.props;

    return (
      <FilterSidebarWrapper
        basePath={basePath}
        location={location}
        pageParameters={pageParameters}
        routeString={routeString}
      >
        <FiltersPageStatistics
          pageParameters={pageParameters}
          filters={filters}
        />
        <Filters
          basePath={basePath}
          filters={filters}
          filtersBrandsCount={filtersBrandsCount}
          location={location}
          pageParameters={pageParameters}
          routeString={routeString}
        />
      </FilterSidebarWrapper>
    );
  }
}
